import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { useContext, useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";

import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import { t } from "i18next";

import { getApi } from "@beeldit/core/helpers/api";
import useGetConfigurationAction from "@main/configurations/actions/get/useGetConfigurationAction";
import { ConfigurationsContext } from "@main/contexts/ConfigurationsContext";
import { Users } from "@phosphor-icons/react/dist/ssr";
import useGetCommerceAction from "@main/commerces/actions/get-config/useGetCommerceAction";
import useGetTenantAction from "@main/tenants/actions/get/useGetTenantAction";
import {
  ArrowsClockwise,
  Calculator,
  Calendar,
  Database,
  Gear,
  Graph,
  Plugs,
  StackOverflowLogo,
  Stethoscope,
  UserSound,
} from "@phosphor-icons/react";

function Panel() {
  const { tokenLoaded, user } = useContext(AuthContext);

  /** TODO - Encapsular en una logica aparte que además compruebe que estos parametros son numericos */
  const { setTenantId } = useContext(TenantAndCommerceContext);
  const { setCommerceId } = useContext(TenantAndCommerceContext);
  const { getCommerceFunction } = useGetCommerceAction();
  const { getTenantFunction } = useGetTenantAction();

  let { tenantId, commerceId } = useParams();

  useEffect(() => {
    if (!tenantId) {
      tenantId = "1";
    }
    setTenantId(parseInt(tenantId));
    getApi().defaults.headers.common["tenantId"] = tenantId;
    if (!commerceId) {
      commerceId = "1";
    }
    setCommerceId(parseInt(commerceId));
    getApi().defaults.headers.common["commerceId"] = commerceId;
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!tenantId || !commerceId || !tokenLoaded) return;
    getCommerceFunction(parseInt(commerceId));
    getTenantFunction(parseInt(tenantId));
  }, [commerceId, tokenLoaded, tenantId]);

  if (!tokenLoaded || !user) {
    return <div>Loading...</div>;
  }

  const items: any[] = [
    // {
    //   label: t("customers"),
    //   to: `/panel/${tenantId}/${commerceId}/customers`,
    //   icon: <AddressBookTabs size={24} />,
    //   roles: ["admin"],
    // },
    // {
    //   label: t("pets"),
    //   to: `/panel/${tenantId}/${commerceId}/pets`,
    //   icon: <Dog size={24} />,
    //   roles: ["admin"],
    // },
    {
      label: t("customers"),
      to: `/panel/${tenantId}/${commerceId}/customers`,
      icon: <Users size={24} />,
      roles: ["admin", "worker", "superadmin"],
    },
    {
      label: t("treatments"),
      to: `/panel/${tenantId}/${commerceId}/treatments`,
      icon: <UserSound size={24} />,
      roles: ["admin", "worker", "superadmin"],
    },
    {
      label: t("therapists"),
      to: `/panel/${tenantId}/${commerceId}/therapists`,
      icon: <Stethoscope size={24} />,
      roles: ["admin", "superadmin"],
    },
    {
      label: t("sessions"),
      to: `/panel/${tenantId}/${commerceId}/sessions`,
      icon: <Calendar size={24} />,
      roles: ["admin", "worker", "superadmin"],
    },
    {
      label: t("accounting"),
      to: `/panel/${tenantId}/${commerceId}/accounting`,
      icon: <Calculator size={24} />,
      roles: ["admin", "superadmin"],
    },
    // {
    //   label: t("new_booking"),
    //   to: `/panel/${tenantId}/${commerceId}/booking?new=true`,
    //   icon: <CalendarPlus size={24} />,
    //   roles: ["admin", "worker"],
    // },
    // {
    //   label: t("bookings"),
    //   to: `/panel/${tenantId}/${commerceId}/bookings`,
    //   icon: <CalendarDots size={24} />,
    //   roles: ["admin", "worker"],
    // },
    // {
    //   label: t("arrival_bookings"),
    //   to: `/panel/${tenantId}/${commerceId}/arrival-bookings`,
    //   icon: <SignIn size={24} />,
    //   roles: ["admin", "worker"],
    // },
    // {
    //   label: t("departure_bookings"),
    //   to: `/panel/${tenantId}/${commerceId}/departure-bookings`,
    //   icon: <SignOut size={24} />,
    //   roles: ["admin", "worker"],
    // },
    // {
    //   label: t("calendar"),
    //   to: `/panel/${tenantId}/${commerceId}/bookings-calendar`,
    //   icon: <Calendar size={24} />,
    //   roles: ["admin", "worker"],
    // },
    // {
    //   label: t("payments"),
    //   to: `/panel/${tenantId}/${commerceId}/payments`,
    //   icon: <Coins size={24} />,
    //   roles: ["admin"],
    // },
    {
      label: t("configurations"),
      icon: <Gear size={24} />,
      roles: ["admin", "superadmin"],
      children: [
        {
          label: t("users"),
          to: `/panel/${tenantId}/${commerceId}/configurations/users`,
          icon: <Users size={24} />,
          roles: ["admin", "superadmin"],
        },
        {
          label: t("users_activity"),
          to: `/panel/${tenantId}/${commerceId}/configurations/users-activity`,
          icon: <StackOverflowLogo size={24} />,
          roles: ["admin", "superadmin"],
        },
        {
          label: t("updates"),
          to: `/panel/${tenantId}/${commerceId}/configurations/updates`,
          icon: <ArrowsClockwise size={24} />,
          roles: ["admin", "superadmin"],
        },
        {
          label: t("integrations"),
          to: `/panel/${tenantId}/${commerceId}/configurations/integrations`,
          icon: <Plugs size={24} />,
          roles: ["admin", "superadmin"],
        },
        {
          label: t("reports"),
          to: `/panel/${tenantId}/${commerceId}/configurations/reports`,
          icon: <Graph size={24} />,
          roles: ["admin", "superadmin"],
        },
        {
          label: t("bd_connections"),
          to: `/panel/${tenantId}/${commerceId}/configurations/bd-connections`,
          icon: <Database size={24} />,
          roles: ["admin", "superadmin"],
        },
      ],
    },
  ];

  return (
    <div>
      <div className="admin container-fluid">
        <Sidebar items={items} />
        <div className="page-content">
          <Outlet />
          <div className="text-end text-secondary mt-3">
            Licencia: Cristina Ruiz Alhama
          </div>
        </div>
      </div>
    </div>
  );
}

export default Panel;
